import { render, staticRenderFns } from "./TLocationTagInner.vue?vue&type=template&id=615bd08b&scoped=true&"
import script from "./TLocationTagInner.vue?vue&type=script&lang=js&"
export * from "./TLocationTagInner.vue?vue&type=script&lang=js&"
import style0 from "./TLocationTagInner.vue?vue&type=style&index=0&id=615bd08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615bd08b",
  null
  
)

/* custom blocks */
import block0 from "./TLocationTagInner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports